import React from "react";
import { useQuery } from "@apollo/client/react";
import { useParams } from "react-router";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { FETCH_PROJECT_QUERY } from "../../constants/graphql/queries";

const ProjectContext = React.createContext();

export default function ProjectProvider({ children, projectId: propsProjectId }) {
  const { projectId: routeProjectId } = useParams();
  const projectId = propsProjectId || routeProjectId;
  const { data: { project = {} } = {}, loading } = useQuery(FETCH_PROJECT_QUERY, {
    variables: { id: projectId },
    skip: !projectId,
  });
  const client = project?.client;

  return (
    <ProjectContext.Provider value={{ project, client }}>
      {loading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress color="primary" size={22} />
        </Box>
      ) : (
        children
      )}
    </ProjectContext.Provider>
  );
}

export const useProject = () => {
  const context = React.useContext(ProjectContext);
  if (context === undefined) {
    throw new Error("useProject must be used within a ProjectProvider");
  }
  return context;
};
